import infoIcon from 'assets/icons/info-blue.svg';
import React, { useContext } from 'react';
import { Card, LocaleContext, NotificationsContext, NotificationTypes, SecretField } from 'shared';
import { CertificateType } from 'store/api/types';

import { CertificatesGroupContainer } from './certificatesGroup/CertificatesGroupContainer';
import { IntegrationDataCertificatesInfo, IntegrationDataWrapper } from './IntegrationData.styles';
import { IntegrationDataProps } from './IntegrationData.types';

export const IntegrationData = ({ clientId, applicationId, accountId }: IntegrationDataProps) => {
  const localeContext = useContext(LocaleContext);
  const notificationsContext = useContext(NotificationsContext);

  const handleCopy = () => {
    notificationsContext.showNotification({
      message: localeContext.formatMessage({ id: 'INTEGRATION-DATA.COPY-SUCCESS' }),
      time: 1000,
      type: NotificationTypes.SUCCESS,
    });
  };

  return (
    <Card className="application-card integration-data__container">
      <Card.Header className="integration-data__header">
        <Card.Title>{localeContext.formatMessage({ id: 'INTEGRATION-DATA.TITLE' })}:</Card.Title>
      </Card.Header>
      <Card.Body>
        <IntegrationDataWrapper>
          <Card.Item className="integration-data__row">
            <Card.ItemKey className="integration-data__label">
              {localeContext.formatMessage({ id: 'INTEGRATION-DATA.CLIENT-ID' })}:
            </Card.ItemKey>
            <Card.ItemValue className="integration-data__value">
              <SecretField
                copyText={localeContext.formatMessage({ id: 'GENERAL.COPY' })}
                hideText={localeContext.formatMessage({ id: 'GENERAL.HIDE' })}
                showText={localeContext.formatMessage({ id: 'GENERAL.SHOW' })}
                value={clientId}
                onCopy={handleCopy}
              />
            </Card.ItemValue>
          </Card.Item>
          <IntegrationDataCertificatesInfo className="integration-data__certificates-info">
            <img
              src={infoIcon}
              alt={localeContext.formatMessage({ id: 'INTEGRATION-DATA.CERTIFICATES.INFO-ALT-TEXT' })}
            />
            <p>{localeContext.formatMessage({ id: 'INTEGRATION-DATA.CERTIFICATES.INFO' })}</p>
          </IntegrationDataCertificatesInfo>
          <CertificatesGroupContainer
            accountId={accountId}
            applicationId={applicationId}
            certificateType={CertificateType.QWAC}
          />
          <CertificatesGroupContainer
            accountId={accountId}
            applicationId={applicationId}
            certificateType={CertificateType.QSEALC}
          />
        </IntegrationDataWrapper>
      </Card.Body>
    </Card>
  );
};
